import React from 'react';

import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { scanIqRegistrationService } from '../../../../auth-management';
import { RegistrationFormAccessWidget } from '../../../../auth-management/components/RegistrationFormAccessWidget/RegistrationFormAccessWidget';
import { NgzManageInbodyPinCodeWidget } from '../../../../inbody/containers/NgzManageInbodyPinCodeWidget/NgzManageInbodyPinCodeWidget';

const ScanIqRegistrationTab = () => {
  const entityId = loggedInUserDataStore.getEntityId();

  return (
    <div>
      <RegistrationFormAccessWidget
        id={entityId}
        getRegistrationLink={scanIqRegistrationService.getRegistrationLink}
        getRegistrationQrCode={scanIqRegistrationService.getRegistrationQrCode}
        qrCodeDescription="A QR code has already been generated and assigned to your entity"
      />
      <NgzManageInbodyPinCodeWidget entityId={entityId} />
    </div>
  );
};

export { ScanIqRegistrationTab };
